<template>
  <WdsTooltip :text="text" v-bind="$attrs" left>
    <slot>
      <i class="c-indigo-500 zmdi zmdi-help" :class="$attrs.class"></i>
    </slot>
  </WdsTooltip>
</template>

<script>
import { WdsTooltip } from '@worksome/wds-components'
import { computed } from 'vue'

const TOOLTIP_TEXT_DEFAULT = `A company registration number is the number used to
  identify a company in the country where it operates.  It is often issued by
  business or tax-related authorities, and is unique to a company or legal entity.`

const TOOLTIP_TEXT_MARKETS = {
  AU: `The Australian Business Number (ABN) is a unique 11 digit number
    that identifies your business to the government and community.`,
  CA: `A business number is unique to your business and issued by the Canadian Revenue Agency.
    It is 15 digits long and presented as xxxxxxxxxRTxxxx`,
  CA_Q: `A business number is unique to your business and, since the business is based in the province of Quebec,
    will have been issued with a Quebec Enterprise Number (NEQ). It is 10 digits long and presented as 1234567890.`,
  IE: `A company registration number is a unique code, that identifies
    companies in Ireland. It is issued by Companies House, and is
    unique to a company or legal entity.`,
  SG: `The Unique Entity Number (UEN) is a 9 or 10 digit identification
    number that is issued by the government in Singapore to all entities
    that operate within the country.`,
  UK: `A company registration number is a unique, 8-character code
    that identifies companies in the UK.  It is issued by Companies
    House, and is unique to a company or legal entity.`,
  US: `A Federal Tax Identification Number (FEIN) is also known as an Employer
    Identification Number (EIN), and is used to identify a business entity.
    Generally, businesses need an EIN and it can be obtained for free from
    the Internal Revenue Service.`,
  DE: `You can use either the Steuernummer or the Ust-ID number. If you work for another EU country, please enter your Ust-ID number.`,
}

export default {
  components: {
    WdsTooltip,
  },
  props: {
    market: {
      type: String,
      default: null,
    },
  },
  setup(props) {
    const text = computed(() => {
      if (props.market === null) {
        return TOOLTIP_TEXT_DEFAULT
      }
      if (TOOLTIP_TEXT_MARKETS.hasOwnProperty(props.market)) {
        return TOOLTIP_TEXT_MARKETS[props.market]
      }
      return TOOLTIP_TEXT_DEFAULT
    })
    return { text }
  },
}
</script>
